module.exports = __webpack_public_path__ + "static/img/DSC_0092_03.b3999022.png";